import { gql } from '../../../artifacts/gql';

export const Money = gql(`
  fragment Money on Money {
    amountInCents
    currency
  }
`);

export const paymentMethodsFragment = gql(`
  fragment PaymentMethods on CollectCurrentUser {
    collectPaymentMethods {
      id
      ... on CollectPaymentMethodCard {
        card {
          brand
          expirationMonth
          expirationYear
          lastFour
        }
        isDefault
      }
      ... on CollectPaymentMethodBank {
        bank {
          lastFour
          name
        }
        isDefault
      }
      ... on CollectPaymentMethodOther {
        id
        isDefault
      }
    }
  }
`);
export const getWalletDataQuery = gql(`
  query webGetWalletDataCCQuery($enableFancash: Boolean!, $enableRewards: Boolean!) {
    collectCurrentUserV2 {
      tenantId
      ...PaymentMethods
      accountFunds {
        usableFunds {
          ...Money
        }
      }
    }
    currentBalance @include(if: $enableRewards) {
      amount
      currency
      amountDisplay
    }
    fancashBalance @include(if: $enableFancash) {
      balance {
        amount
        currency
        amountDisplay
      }
    }
  }
`);
